<template>
  <div class="box mt-0 px-0">
    <v-layout
      class="wrapper text-xs-center"
      :style="{ 'min-height': `${minHeight}px` }"
      align-center
      justify-center
      fill-height
      row
    >
      <div class="box__empty-state">
        <p><strong v-html="$t(`${namespace}.emptyState.title`)" /></p>
        <p class="mb-0">
          <span v-html="$t(`${namespace}.emptyState.text`)" /><br class="hidden-sm-and-down"><a href="https://99empresas.zendesk.com/hc/pt-br" :title="$t('Common.clickHere')" target="_blank" class="text--link accent--text">{{ $t('Common.clickHere') }}</a>&nbsp;<span v-html="$t(`${namespace}.emptyState.andKnowHow`)" />
        </p>
      </div>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    minHeight: {
      type: Number,
      default: 422
    }
  },
  data () {
    return {
      namespace: 'Components.Performance'
    }
  }
}
</script>

<style lang="scss" scoped>
.box__empty-state {
  font-size: 12px;
  padding: 0 24px;

  p {
    color: $gray-6;
  }
}
</style>
